import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';

const AddDetail = ({
    open,
    onClose,
    onSubmit,
    name,
    min,
    max,
}) => {
    const [detail, setDetail] = useState({
        name: '',
        value: '',
    });
    const [errors, setErrors] = useState({});

    const validate = (values) => {
        const newErrors = {};
        if (!values.name) newErrors.name = 'Required';
        if (!values.value) newErrors.value = 'Required';
        
        const value = parseInt(values.value, 10);
        if (isNaN(value)) newErrors.value = 'Must be a number';
        if (value < min) newErrors.value = `Minimum value is ${min}`;
        if (value > max) newErrors.value = `Maximum value is ${max}`;

        return newErrors;
    };

    const handleChange = field => (event) => {
        const newDetail = {
            ...detail,
            [field]: event.target.value,
        };
        
        const fieldErrors = validate(newDetail);
        setErrors(prev => ({
            ...prev,
            [field]: fieldErrors[field] || '',
        }));
        
        setDetail(newDetail);
    };

    const handleSubmit = () => {
        const newErrors = validate(detail);
        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            onSubmit(detail);
            setDetail({ name: '', value: '' });
        }
    };

    const handleClose = () => {
        setDetail({ name: '', value: '' });
        setErrors({});
        onClose();
    };

    const actions = [
        <FlatButton
            label='Cancel'
            onClick={handleClose}
        />,
        <FlatButton
            label='Add'
            primary
            onClick={handleSubmit}
        />,
    ];

    return (
        <Dialog
            title={`Add ${name}`}
            actions={actions}
            modal={false}
            open={open}
            onRequestClose={handleClose}
        >
            <div className='row'>
                <div className='col-xs-6'>
                    <TextField
                        floatingLabelText='Value'
                        value={detail.value}
                        onChange={handleChange('value')}
                        errorText={errors.value}
                        fullWidth
                    />
                </div>
                <div className='col-xs-6'>
                    <TextField
                        floatingLabelText='Name'
                        value={detail.name}
                        onChange={handleChange('name')}
                        errorText={errors.name}
                        fullWidth
                    />
                </div>
            </div>
        </Dialog>
    );
};

AddDetail.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
};

export default AddDetail;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/LiftAndCranes/Misc/AddDetail.jsx